import { environment } from '@env/environment';

export enum FileUploadType {
  BatchUpdate = 1,
  BatchUpdateContext = 2,
  AntennaGrid = 3,
  RestitFile = 4,
  BatchUpdatePrices = 5,
}

export enum DownloadableExcelFileType {
  BatchUpdateReport = 1,
  BatchUpdateFlashReport = 2,
  PriceListFlashReport = 3,
  PriceListReport = 4,
}

export const fileUploadNameRoute = {
  batchUpdate: environment.api_base_url + '/tv/channel-batch-update/upload-channel-grid-to-s3',
  batchUpdateContext: environment.api_base_url + '/tv/channel-batch-update/upload-grid-week-type-upload-to-s3',
  batchUpdatePrices: environment.screen_spot_microservice_base_url + '/upload-file-to-s3',
  priceList: environment.price_list_microservice_base_url + '/upload-file-to-s3',
};

export function getUploadFileRouteName(fileType: FileUploadType): string {
  switch (fileType) {
    case FileUploadType.BatchUpdate:
      return fileUploadNameRoute.batchUpdate;
    case FileUploadType.BatchUpdateContext:
      return fileUploadNameRoute.batchUpdateContext;
    case FileUploadType.BatchUpdatePrices:
      return fileUploadNameRoute.batchUpdatePrices;
    case FileUploadType.AntennaGrid:
      return fileUploadNameRoute.priceList;
    case FileUploadType.RestitFile:
      return fileUploadNameRoute.priceList;
    default:
      return '';
  }
}

export function getDownloadFileLink(fileType: DownloadableExcelFileType): string {
  switch (fileType) {
    case DownloadableExcelFileType.BatchUpdateReport:
      return environment.api_base_url + '/tv/download-tv-batch-update-report';

    case DownloadableExcelFileType.BatchUpdateFlashReport:
      return environment.api_base_url + '/tv/download-tv-batch-update-flash';

    case DownloadableExcelFileType.PriceListFlashReport:
      return environment.price_list_microservice_base_url + '/download-file-from-s3';

    case DownloadableExcelFileType.PriceListReport:
      return environment.price_list_microservice_base_url + '/download-file-from-s3';

    default:
      return '';
  }
}

export interface IFileModel {
  fileName: string;
  data: any;
}

export class FileModel implements IFileModel {
  public fileName: string;
  public data: any;
  constructor(json: IFileModel) {
    this.fileName = json.fileName;
    this.data = json.data;
  }
}
